import { useState } from 'react';
import type { ChartStakeholder } from '@integratio/core';

interface Props {
  stakeholders: ChartStakeholder[];
  emptyText: string;
  /** Quantidade exibida antes do "ver todos". Use Infinity na impressão. */
  limit?: number;
  compact?: boolean;
}

export function StakeholderGroupList({ stakeholders, emptyText, limit = 6, compact = false }: Props): JSX.Element {
  const [expanded, setExpanded] = useState(false);

  if (stakeholders.length === 0) {
    return <p className="text-[11px] font-medium uppercase tracking-wide text-brand-slate/70">{emptyText}</p>;
  }

  const visible = expanded || limit === Infinity ? stakeholders : stakeholders.slice(0, limit);
  const hidden = stakeholders.length - visible.length;

  return (
    <div>
      <ul className={compact ? 'space-y-0.5' : 'space-y-1'}>
        {visible.map((item) => (
          <li key={item.id} className="flex gap-1.5 text-[11px] leading-snug text-brand-graphite">
            <span className="text-brand-slate/60 tabular-nums">{item.numero ? `${item.numero}.` : '•'}</span>
            <span>
              <span className="font-medium">{item.nome}</span>
              {(item.cargo || item.empresaInstituicao) && (
                <span className="block text-[9px] text-brand-slate/80">
                  {[item.cargo, item.empresaInstituicao].filter(Boolean).join(' — ')}
                </span>
              )}
            </span>
          </li>
        ))}
      </ul>
      {hidden > 0 && (
        <button
          type="button"
          className="no-print mt-1.5 text-[11px] font-semibold text-brand-red hover:text-brand-redDark"
          onClick={() => setExpanded(true)}
        >
          + {hidden} stakeholder{hidden > 1 ? 's' : ''}
        </button>
      )}
    </div>
  );
}
